var errorPosted = false;
window.onerror =  function(msg, url, line){
	   if(!errorPosted){
		   errorPosted = true;
	       var scripterrorlog = line + '|' + msg + '|' + url;
			var url = URL_MAPPING.resolveUrl('/common/error');

	       $.post(url, { userAgent : window.navigator.userAgent, msg: scripterrorlog });
	       return false;
	   }
};